


























import { Component, Vue } from 'vue-property-decorator'
import { queryNews } from '@/api/api'
import moment from 'moment'

@Component({})
export default class BigEvent extends Vue {
  eventList: Array<any> = []
  size: number = 6
  total: number = 0

  mounted() {
    this._queryNews()
  }

  /**
   * 页数切换
   */
  handleCurrentChange(page: number) {
    this._queryNews(page)
  }

  /**
   * 跳转详情
   */
  jumpDetails({ news_type_diy, external_links, news_title, news_content, creeTime }: any) {
    if (news_type_diy == '0') {
      this.$router.push({
        name: 'BigEventDetails',
        params: {
          external_links,
          news_title,
          news_content,
          creeTime
        }
      })
    } else {
      window.open(external_links)
    }
  }

  /**
   * 查询已发布企业大事件
   * @param page 页码
   * @param size 数量
   */
  _queryNews(page: number = 1, size: number = this.size): void {
    const load = this.$loading({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    queryNews({
      page,
      size
    })
      .then((res: any) => {
        load.close()
        this.total = res.data.result.total
        const arr = res.data.result.records
        for (let i = 0, len = arr.length; i < len; i++) {
          arr[i].creeTime = moment(arr[i].creeTime).format('YYYY-MM-DD')
        }
        this.eventList = res.data.result.records
      })
      .catch(_ => {
        load.close()
      })
  }
}
